// extracted by mini-css-extract-plugin
module.exports = {"block":"MegaBoard_block__aXP_X","header":"MegaBoard_header__w4Asj","joinBtn":"MegaBoard_joinBtn__r5ujb","row":"MegaBoard_row__mvJzh","list":"MegaBoard_list__ldkV0"};